import React from 'react';
import Billing from '../../../pages/Billing';

const AIBilling: React.FC = () => {
  return <Billing />;
};

export default AIBilling;